/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class ScrollingTables {


    /**
     * Wraps a container around a table. If the table is wider than the container, it will scroll
     * @param {HTMLElement} elem A html table element
     */
    static makeTableScroll(table) {
        let wrapper = document.createElement("div");
        wrapper.setAttribute("class", "tablewrapper");
        table.parentElement.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    }

    /**
     * Loops through all tables in the container, and makes them scroll, if they are too wide.
     * @param {HTMLElement} container The parent container of which all tables that are children, will be scrolling, if they are too wide for the container
     */
    static makeAllTablesScroll(container) {
        if (container == undefined) {
            container = document.querySelector("body");
        }
        let tables = container.querySelectorAll("table");
        [].forEach.call(tables, (t) => {
            ScrollingTables.makeTableScroll(t);
        });
    }
}

export default ScrollingTables;